<script setup>
import axios from "axios";
import { onMounted, ref, watch } from "vue";

const props = defineProps({
  client_id: String,
});

const payment_history_url = 'client_payment_history/';
const payment_history_data = ref(null);

const fetchPaymentHistory = async () => {
  if (!props.client_id) {
    console.warn("No client_id given: ", props.client_id);
    return;
  }
  try {
    const res = await axios.get(payment_history_url, {
      params: {
        client_id: props.client_id,
      },
    });
    if (res.data) {
      payment_history_data.value = res.data;
    }
  } catch (err) {
    console.error("Error fetching payment history for client_id:", err);
  }
};

const sanitizeId = (address) => {
  return address.replace(/\s+/g, '_').replace(/[^\w\-]/g, '');
};

// Watch for changes in client_id and refetch the data
watch(() => props.client_id, (newVal) => {
  if (newVal) {
    fetchPaymentHistory();
  }
});

// Fetch data on component mount
onMounted(() => {
  fetchPaymentHistory();
});
</script>


<template>
  <div class="container" v-if="payment_history_data">
    <div
      v-for="(payments, address) in payment_history_data"
      :key="address"
      class="list-group"
    >
      <!-- Collapsible Header -->
      <div
        :id="sanitizeId(address)"
        class="list-group-item list-group-item-action"
        type="button"
        data-bs-toggle="collapse"
        :data-bs-target="'#collapseRow' + sanitizeId(address)"
        aria-expanded="false"
        :aria-controls="'collapseRow' + sanitizeId(address)"
      >
        <label>{{ address }}</label>
      </div>

      <!-- Collapsible Content -->
      <div :id="'collapseRow' + sanitizeId(address)"
           class="collapse border container-fluid  table-responsive list-group-item"
      >
        <table class="table table-hover table-striped-columns table-light">
          <thead>
          <tr class="table-header">
            <td>Оплачено</td>
            <td>Начислено</td>
            <td>Дата расчета</td>
            <td>Дата оплаты</td>
            <td>Дата транзакции</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="payment in payments" :key="payment.id">
            <td>{{ payment.paid }}</td>
            <td>{{ payment.accrued }}</td>
            <td>{{ payment.period_date }}</td>
            <td>{{ payment.payment_date }}</td>
            <td>{{ payment.transaction_date }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>


<style scoped>

</style>